import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'

import store from '@/store'
import { Route } from 'vue-router'

const name = 'list'

export enum ListType {
  Unknown,
  Company,
  Deal,
  Venue
}

function getDefaultFiltersFromListType(listType: ListType): any {
  switch (listType) {
    case ListType.Company:
      return { active: [true] }
    case ListType.Deal:
      return {
        status: [
          'active',
          'draft',
          'review_pending',
          'reviewed',
          'changes_pending',
          'approved',
          'paused'
        ]
      }
    case ListType.Venue:
      return { enable: [true] }
    default:
      return {}
  }
}

function getListTypeFromRoute(route: Route): ListType {
  if (route.name === 'Companies') return ListType.Company
  if (route.name === 'AllVenues') return ListType.Venue
  if (route.name === 'AllDeals') return ListType.Deal

  return ListType.Unknown
}

const defaultFilters = {
  [ListType.Company]: { active: [true] },
  [ListType.Deal]: {
    status: [
      'active',
      'draft',
      'review_pending',
      'reviewed',
      'changes_pending',
      'approved',
      'paused',
      'hidden'
    ]
  },
  [ListType.Venue]: { enable: [true] },
  [ListType.Unknown]: {}
}

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class ListModule extends VuexModule {
  private filterValues: any = { ...defaultFilters }
  private itemsPerPage = 20
  private pages = 1
  private listType: ListType = ListType.Unknown

  public get filters(): any {
    return this.filterValues[this.listType]
  }

  public get allFilters(): any {
    return this.filterValues
  }

  public get totalPages(): any {
    return this.pages
  }

  public get perPage() {
    return this.itemsPerPage
  }

  @Mutation
  private setFilter(property?: { key: string; value: string[] }): void {
    console.log('setFilter', property)
    if (!property) {
      this.filterValues = { ...defaultFilters }
    } else if (property.value.length === 0) {
      this.filterValues[this.listType][property.key] = undefined
    } else {
      this.filterValues[this.listType][property.key] = property.value
    }
  }

  @Mutation
  private setPages(payload: number) {
    this.pages = payload
  }

  @Mutation
  private setListType(payload: ListType) {
    this.listType = payload
  }

  @Mutation
  private setItemsPerPage(payload: number) {
    this.itemsPerPage = payload
  }

  @Action({ rawError: true })
  public setFilterValue(property: {
    key: string
    value: string[] | number[]
  }): void {
    this.context.commit('setFilter', property)
  }

  @Action({ rawError: true })
  public resetListValues(route?: Route): void {
    if (route) {
      this.context.commit('setListType', getListTypeFromRoute(route))
    }
    this.context.commit('setFilter')
  }

  @Action({ rawError: true })
  public setPerPage(payload: number) {
    this.context.commit('setItemsPerPage', payload)
  }

  @Action({ rawError: true })
  public setTotalPages(payload: number) {
    this.context.commit('setPages', payload)
  }
}

export default getModule(ListModule)
